import { ObjectID } from 'mongodb'
import { Dictionary } from './misc'
import { ITag, Indicator } from './indicator'
import { Company } from './company'
import * as FAQ from './faq'
import * as Leadership from './leadership'
import { AccountDetails, MatchedPlaidTransaction, SpendingBreakdownItem, SpendingImpactValueRow } from './plaid-transaction'
import { UserImpact } from './user'

export * from './app-permissions'
export * from './expo-notifications'
export * from './transaction-location'
export * from './plaid-transaction'
export * from './value'
export * from './question'
export * from './user'
export * from './datasource'
export * from './api'
export * from './deals'
export * from './indicator'
export * from './oauth'
export * from './misc'
export * from './company-upload'
export * from './company'
export * from './customer'
export * from './banno-oauth-redirect-base'
export * from './banno-cookie-domain'
export * from './util'
export * from './mappings'
export * from './accounts'
export * from './account-balance'
export * from './events'
export * from './company-info-feedback'
export * from './account-deletion'
export * from './constants'
export * from './analytics'
export * from './alternative-status-phrases'

export { FAQ, Leadership }

/* eslint-disable no-useless-escape */
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const URL_REGEX = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i
export const PHONE_REGEX = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})(\d{0,5})?$|^(\d{10,15})$|^(\+1\d{10,15})$|^(\d{3}[\s.-]?\d{3}[\s.-]?\d{4}(\d{0,5})?)$|^(\(\d{3}\)\s?\d{3}[\s.-]?\d{4}(\d{0,5})?)$|^(\d{3}-\d{3}-\d{4}(\d{0,5})?)$|^(\d{3}\.\d{3}\.\d{4}(\d{0,5})?)$|^(\d{3}\s\d{3}\s\d{4}(\d{0,5})?)$|^(\d{3}\d{3}\d{4}(\d{0,5})?)$/

export type TxSummary = {
  amount: number;
  score: number;
}

export interface DailyUserSummary {
  userId?: ObjectID;
  date?: Date;
  total?: number; // sum(amount * score)
  outOf?: number;
  dailyScore?: number;
  rolling7Score?: number;
  rolling30Score?: number;
  txScoreMap: Dictionary<TxSummary>;
}


export type FeaturedTag = ITag & { companies: Company[] }

export interface ISegment {
  tags: ITag[];
  subsegments: string[];
  name: string;
}

export interface IApiKey {
  _id: string;
  label: string;
  usage?: Dictionary<number>;
  lastUsed: string;
  created: Date;
}

export interface SelectedIcon {
  family: string
  name: string
}

export interface IImpactArea {
  _id: string
  label: string
  // value where it's displayed in chooser
  valueSlug: string
  icon?: SelectedIcon
  description?: string
  impactLanguage?: string

  // needed for ui
  amount?: number
  hexColor?: string
}

export type UIImpactArea = IImpactArea & {
  indicators?: Indicator[]
}

export type MatchedAccountInfo = {
  institutionName: string,
  item_id: string,
  account: AccountDetails | null
}

export type DashboardImpactSummary = UserImpact & {
  transactions: MatchedPlaidTransaction[],
  spendingBreakdown: Record<string, SpendingBreakdownItem>,
  spendingImpactValueRows?: SpendingImpactValueRow[],
}

export const GENDER_IDENTITIES = [
  "Agender",
  "Genderqueer",
  "Gender Fluid",
  "Man",
  "Unsure/Questioning",
  "Woman",
  "Prefer not to say",
  "Other (Please Specify)"
]

export const SEXUAL_ORIENTATION_IDENTITIES = [
  "Bisexual",
  "Gay",
  "Lesbian",
  "Pansexual",
  "Queer",
  "Straight",
  "Unsure/Questioning",
  "Prefer not to say",
  "Other (Please Specify)"
]

export const RACE_ETHNICITY_IDENTITIES = [
  "American Indian or Alaska Native",
  "Asian",
  "Black or African American",
  "Hispanic or Latino",
  "Middle Eastern or North African",
  "Native Hawaiian or Other Pacific Islander",
  "White",
]

export const NotificationChannels = {
  DEFAULT: 'default', // default channel for updates, insights, etc
  WARNING: 'warning', // warning channel for important updates, alerts, etc
  URGENT: 'urgent', // urgent channel for critical updates, alerts, etc
}